module.exports = __webpack_public_path__ + "static/img/main_point_img03.5573b2ce.svg";